// @ts-check
import React, { Component } from 'react';
import './App.css';

import 'bootstrap/dist/css/bootstrap.css';
import { I18n } from 'react-i18next';
import * as d3 from 'd3v4';
import * as IframeResizer from 'iframe-resizer';

import { VizPaises } from './components/VizPaises';
import i18n from './i18n';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      baseUrl: null
    };
  }

  render() {
    const baseUrl = this.state.baseUrl;
    if (baseUrl) {
      return (
        <I18n ns="translations">{(t, { i18n }) => <VizPaises t={t} baseUrl={baseUrl} />}</I18n>
      );
    } else {
      return <div />;
    }
  }
  componentDidMount() {
    // let baseUrl = `https://golyfutbol-widget-data.s3.amazonaws.com/paises-copa-mundo`;
    // this.setState({ baseUrl: baseUrl });
    window.addEventListener('message', this.receiveMessage.bind(this), false);
  }
  ifIsAuthorizedOrigin(event, authorizedCallback) {
    if (!event.origin) return;
    let domainPattern = /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:/\n]+)/im;
    let domain = domainPattern.exec(event.origin)[1];
    console.log(`CHECKING: ${domain}`);
    let authorizationUrl = `https://golyfutbol-widget-auth.s3.amazonaws.com/paises-copa-mundo/${domain}`;
    // const reqOrigenes =
    d3.text(authorizationUrl, (error, data) => {
      if (error || data.length <= 0) {
        throw new Error('Origin not authorized.');
      } else {
        console.log(`AUTHORIZED: ${domain}`);
        authorizedCallback(event);
      }
    });
  }
  receiveMessage(event) {
    // Validar contenido del mensaje.
    if (!(event.data && event.data.messageType === 'iframe-data')) return;
    this.ifIsAuthorizedOrigin(event, () => {
      // Armar URL a partir del id de liga que llegó.
      let baseUrl = `https://golyfutbol-widget-data.s3.amazonaws.com/paises-copa-mundo`;
      this.setState({ baseUrl: baseUrl });
    });
  }
}
export default App;



// WEBPACK FOOTER //
// ./src/App.js